import { api } from 'data/api/api'

import { PhotoTipResp, PhotoTipsResp } from '../types/photo-tips'
import { EntryType } from '../constants'

export const getPhotoTips = (entryType = EntryType.Default) =>
  api.get<PhotoTipsResp>('/photo_tips', {
    params: { entry_type: entryType },
  })

export const getPhotoTip = (id: number) => api.get<PhotoTipResp>(`/photo_tips/${id}`)
